import React from 'react';
import MissionProfile from './missionsComponent/missionsProfile';
import RocketProfile from './rocketsComponent/RocketProfile';

const MyProfile = () => (

  <main className="profile-main">
    <MissionProfile />
    <RocketProfile />
  </main>
);

export default MyProfile;
